<script setup lang="ts">
import DoneIcon from '~/components/atoms/icons/DoneIcon.vue'

const MAX_BADGE_COUNT = 20

const props = defineProps<{
  badgeCount: number
}>()

const displayCount = computed(() => {
  return props.badgeCount >= MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : props.badgeCount
})
</script>

<template>
  <div class="todo-badge">
    <div v-if="props.badgeCount > 0" class="badge-count">{{ displayCount }}</div>
    <DoneIcon :size="30" />
  </div>
</template>

<style scoped lang="scss">
.todo-badge {
  position: relative;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;

  .badge-count {
    position: absolute;
    top: -2px;
    right: -4px;
    background-color: var(--semantic-tokens-danger-strong-surface);
    color: var(--semantic-tokens-inverse-default-text);
    font-size: 12px;
    font-weight: 700;
    padding: 0 4px;
    border-radius: 8px;
    min-width: 16px;
    min-height: 16px;

    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
